import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ISRResponse } from '_core/types';
import { AccountIssueTypes } from '../Types';

const machine = Machines.onAccountIssue.machine;

export const accountIssue = (
  params: AccountIssueTypes.AccountIssueServiceRequestType,
): Promise<ISRResponse> => {
  return callServiceMachine(machine, params);
};

export default { accountIssue };
